import React from "react"

import globalStyles from "../../../../App.module.scss"
import {Prism as SyntaxHighlighter} from "react-syntax-highlighter"
import {dracula} from "react-syntax-highlighter/dist/cjs/styles/prism"

let execExample = `# -exec: runs the command once per file (or use + to batch)
find . -name "*.tmp" -exec rm {} \\;
find . -name "*.tmp" -exec rm {} +

# Equivalent with xargs, generally faster (batches automatically)
find . -name "*.tmp" -print0 | xargs -0 rm`

let chainExample = `find . -name "*.log" -print0 | xargs -0 -I{} sh -c 'gzip "{}" && echo "done: {}"'`

export default function FindAndXargs() {
    return (
        <div className={globalStyles.article}>
            <h1>find + xargs</h1>
            <p><code>find</code> locates files by criteria; piping matches into <code>xargs</code> (or using
                <code> -exec</code> directly) applies a command to each of them.</p>

            <h3>Common find flags</h3>
            <div className={globalStyles.styledTable}>
                <table style={{minWidth: '500px'}}>
                    <thead>
                    <tr>
                        <th>Flag</th>
                        <th>Meaning</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><code>-name "*.log"</code></td>
                        <td>Match by filename glob (case-sensitive)</td>
                    </tr>
                    <tr>
                        <td><code>-iname</code></td>
                        <td>Same, case-insensitive</td>
                    </tr>
                    <tr>
                        <td><code>-type f</code></td>
                        <td>Regular files only (<code>d</code> for directories, <code>l</code> for symlinks)</td>
                    </tr>
                    <tr>
                        <td><code>-mtime -7</code></td>
                        <td>Modified within the last 7 days (<code>+7</code> for older than)</td>
                    </tr>
                    <tr>
                        <td><code>-size +100M</code></td>
                        <td>Larger than 100 MB</td>
                    </tr>
                    <tr>
                        <td><code>-maxdepth 2</code></td>
                        <td>Don't recurse past 2 directory levels</td>
                    </tr>
                    <tr>
                        <td><code>-not -path "*/node_modules/*"</code></td>
                        <td>Exclude a path</td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <h3>-exec vs. piping to xargs</h3>
            <SyntaxHighlighter
                children={execExample}
                style={dracula}
                PreTag="div"
                language={'bash'}
            />
            <p>Always prefer <code>-print0</code> / <code>xargs -0</code> over plain newline-delimited output
                when filenames might contain spaces or newlines — the null byte can't appear in a filename, so
                it's the only fully safe delimiter.</p>

            <h3>Chaining multiple commands per file</h3>
            <SyntaxHighlighter
                children={chainExample}
                style={dracula}
                PreTag="div"
                language={'bash'}
            />
        </div>
    )
}
